import React from 'react'
import styled from 'styled-components'

import { MOBILE_BREAKPOINT } from 'broker/util/constants'

const Card = ({ className, children }) => (
  <div className={className}>
    {children}
  </div>
)

export default styled(Card)`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);
  padding: 16px 24px;
  margin: 0 12px;
  
  :first-child {
    margin-left: 0;
  }
  
  :last-child {
    margin-right: 0;
  }
  
  @media${MOBILE_BREAKPOINT} {
    flex-basis: 100%;
    margin: 12px 0;
  
    :first-child {
      margin-top: 0;
    }
    
    :last-child {
      margin-bottom: 0;
    }
  }
`
